import { createSlice } from "@reduxjs/toolkit"
import { BusinessCardsState } from "./types"
import { ErrorType } from "@/shared/types"
import { fetchBusinessCards, createBusinessCard } from "./business-cards-thunk"

const initialState: BusinessCardsState = {
    cards: [],
    isLoading: false,
    firstLoad: true,
    error: null
}

const businessCardsSlice = createSlice({
    name: 'businessCards',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchBusinessCards.pending, (state) => {
                state.error = null
                state.isLoading = true
            })
            .addCase(fetchBusinessCards.fulfilled, (state, action) => {
                state.error = null
                state.firstLoad = false
                state.isLoading = false
                state.cards = action.payload
            })
            .addCase(fetchBusinessCards.rejected, (state, action) => {
                state.error = action.payload as ErrorType ?? null
                state.isLoading = false
            })
            .addCase(createBusinessCard.pending, (state) => {
                state.error = null
            })
            .addCase(createBusinessCard.fulfilled, (state, action) => {
                state.error = null
                state.cards = [...state.cards, action.payload]
            })
            .addCase(createBusinessCard.rejected, (state, action) => {
                state.error = action.payload as ErrorType ?? null
            })
    },
})

export default businessCardsSlice.reducer
export const {} = businessCardsSlice.actions

